import React from 'react';
import ReactDOM from 'react-dom';
import App from './App'; // Your main React component

// Get config from window or use defaults
const userConfig = window.embeddedChatbotConfig || {};
const config = {
  assistant_slug: userConfig.assistant_slug || '',
  api_domain: userConfig.api_domain || 'https://aiva.aiintegrations.tech',
  frontend_domain: userConfig.frontend_domain || 'https://aiva.aiintegrations.tech'
};

const container = document.createElement('div');
container.id = 'aii-embed-container';
document.body.appendChild(container);

ReactDOM.render(<App config={config} chatbot={true} />, document.getElementById('aii-embed-container'));

